import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorFundBillView = () => {
  const fundBillView = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-bill/view', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { fundBillView }
}

export default InteractorFundBillView
